<template>
  <v-form ref="form" v-model="valid">
    <v-row>
      <v-col cols="12" class="py-0">
        <v-checkbox id="isCompany" v-model="personalInfo.isCompany" :label="t('LABEL_JE_SUIS_ENTREPRISE')" @change="persistToStore" />
      </v-col>

      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          v-show="personalInfo.isCompany"
          id="companyName"
          v-model="personalInfo.companyName"
          :label="t('LABEL_NOM_ENTREPRISE')"
          :rules="companyValidationRules"
          required
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
      <v-col cols="12" class="py-0">
        <v-radio-group v-model="personalInfo.civility" row :rules="requiredRules" @change="persistToStore">
          <v-radio v-for="civilityItem in civilities" :key="civilityItem.id" :label="civilityItem.name" :value="civilityItem.id" />
        </v-radio-group>
      </v-col>

      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          id="lastName"
          v-model="personalInfo.lastName"
          :label="t('LABEL_NOM')"
          :rules="requiredRules"
          required
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          id="firstName"
          v-model="personalInfo.firstName"
          :label="t('LABEL_PRENOM')"
          :rules="requiredRules"
          required
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>

      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          id="email"
          v-model="personalInfo.email"
          :label="t('LABEL_COURRIEL')"
          type="email"
          :rules="emailRules"
          validate-on-blur
          required
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>

      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="personalInfo.matriculeEmploye"
          :label="t('LABEL_MATRICULE_EMPLOYE')"
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="personalInfo.matriculeEtudiant"
          :label="t('LABEL_MATRICULE_ETUDIANT')"
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
      <v-col cols="12">
        {{ t("LABEL_RECEPTION_DONS_PLANIFIES") }}
        <div v-for="item in receptionsInfosDons" :key="item.id">
          <v-checkbox
            :value="item.id"
            hide-details
            v-model="personalInfo.receptionInfosDons"
            class="my-1"
            :label="item.name"
            @change="persistToStore"
          >
          </v-checkbox>
        </div>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-checkbox v-model="personalInfo.legsPrevu" :label="t('LABEL_LEGS_PREVU')" @change="persistToStore" />
      </v-col>
    </v-row>

    <FormActionBar :cancel-label="t('RETOUR')" :valid-label="t('VALIDER')" @cancel-click="goBack" @valid-click="validate" />
  </v-form>
</template>

<script>
import FormActionBar from "@/components/FormActionBar"
import { mapActions, mapGetters } from "vuex"

export default {
  components: {
    FormActionBar
  },
  data() {
    return {
      valid: false,
      personalInfo: {
        firstName: "",
        lastName: "",
        email: "",
        civility: null,
        isCompany: false,
        companyName: "",
        matriculeEmploye: "",
        matriculeEtudiant: "",
        receptionInfosDons: [],
        legsPrevu: false
      }
    }
  },
  computed: {
    ...mapGetters(["civilities", "t", "isOutlined", "isDense", "receptionsInfosDons"]),
    requiredRules() {
      return [(v) => !!v || this.t("CHAMP_REQUIS")]
    },
    emailRules() {
      return [(v) => !!v || this.t("COURRIEL_REQUIS"), (v) => /.+@.+\..+/.test(v) || this.t("COURRIEL_DOIT_ETRE_VALIDE")]
    },
    companyValidationRules() {
      return [
        (v) => {
          return !this.personalInfo.isCompany || !!v || this.t("NOM_ENTREPRISE_REQUIS")
        }
      ]
    }
  },
  watch: {
    valid() {
      if (this.valid) {
        this.$emit("validateStep")
      } else {
        this.$emit("invalidateStep")
      }
    }
  },
  methods: {
    ...mapActions(["setPersonalInfo"]),
    persistToStore() {
      this.setPersonalInfo(this.personalInfo)
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.persistToStore()
        this.goNext()
        this.$emit("validateStep", 1)
      }
    },
    goBack() {
      this.$emit("to-step", 1)
    },
    goNext() {
      this.$emit("to-step", 3)
    }
  }
}
</script>

<style>
</style>